// === 精簡版：專門對付 Shopify 的博客連結劫持 ===
(function() {
  'use strict';
  
  // 獲取當前語系
  function getCurrentLocale() {
    // 優先從 URL 路徑判斷 /zh-tw/ 或 /ja/
    var pathMatch = window.location.pathname.match(/^\/(ja|zh)(\/|$)/i);
    if (pathMatch) {
      return pathMatch[1].toLowerCase();
    }
    
    // 其次從 Shopify 判斷
    if (typeof Shopify !== 'undefined' && Shopify.locale) {
      var locale = Shopify.locale.toLowerCase();
      if (locale.includes('zh-tw')) return 'zh-tw';
      if (locale.includes('ja')) return 'ja';
    }
    
    return 'en';
  }
  
  // 修正博客 URL
  function fixBlogUrl(url) {
    var locale = getCurrentLocale();

    if (locale === 'en' || !url || !url.includes('/blogs/blog')) {
      return url;
    }
    
    try {
      var urlObj = new URL(url, window.location.origin);
      var pathname = urlObj.pathname;
      var search = urlObj.search;

      // 如果已經有正確語系前綴，不變
      if (pathname.startsWith('/' + locale + '/blogs/blog')) {
        return url;
      }
      
      // 移除錯誤的語系前綴，加上正確的
      var cleanPath = pathname.replace(/^\/(ja|zh)/, '');
      if (cleanPath.startsWith('/blogs/blog')) {
        return '/' + locale + cleanPath + search;
      }
      
      // 如果沒有語系前綴，直接加上
      if (pathname.startsWith('/blogs/blog')) {
        return '/' + locale + pathname + search;
      }
      
    } catch (e) {
      console.warn('URL fix failed:', e);
    }
    
    return url;
  }
  
  // 劫持 setAttribute 方法
  var originalSetAttribute = Element.prototype.setAttribute;
  Element.prototype.setAttribute = function(name, value) {
    if (name === 'href' && value && value.includes('/blogs/blog')) {
      value = fixBlogUrl(value);
    }
    return originalSetAttribute.call(this, name, value);
  };
  
  // 劫持 href 屬性直接賦值
  var originalHrefDescriptor = Object.getOwnPropertyDescriptor(HTMLAnchorElement.prototype, 'href');
  Object.defineProperty(HTMLAnchorElement.prototype, 'href', {
    get: originalHrefDescriptor.get,
    set: function(value) {

      if (value && value.includes('/blogs/blog') ) {
        value = fixBlogUrl(value);
      }
      originalHrefDescriptor.set.call(this, value);
    },
    configurable: true
  });
  
  // 初始修正現有連結
  function fixExistingLinks() {
    document.querySelectorAll('a[href*="/blogs/blog"]').forEach(function(link) {
      var href = link.getAttribute('href');
      var fixedHref = fixBlogUrl(href);
      if (href !== fixedHref) {
        // link.setAttribute('href', fixedHref);
      }
    });
  }
  
  // 頁面載入完成後執行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixExistingLinks);
  } else {
    fixExistingLinks();
  }
  
  // 監聽動態內容變化
  var observer = new MutationObserver(function(mutations) {
    var shouldFix = false;
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        shouldFix = true;
      }
    });
    
    if (shouldFix) {
      setTimeout(fixExistingLinks, 100);
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Shopify 特定事件監聽
  document.addEventListener('shopify:section:load', fixExistingLinks);
  document.addEventListener('shopify:section:reorder', fixExistingLinks);
  
  console.log('🛡️ Blog link protection activated for locale:', getCurrentLocale());
  
})();